
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Przypnij',
	'find_label': 'Znajdź',
	'findCancelLabel': 'Anuluj',
	'dataPaneLabel': 'Dane',
	'sourcePaneLabel': 'Wybrane źródła',
	'sourcePaneContentLabel': 'Wybierz źródło',
	'emptySourcePaneTitle': 'Wybierz źródło',
	'emptySourcePaneCaption': 'Kliknij opcję Wybierz źródło, aby dodać dane, które zostaną użyte do utworzenia kokpitu.',
	'addDataSource': 'Wybierz źródło',
	'addDataDashboardCoachMarkContents': 'Przeciągnij i upuść dane z panelu do kokpitu.',
	'addDataStoryCoachMarkContents': 'Przeciągnij i upuść dane z panelu do scenariusza.',
	'addDataCoachMarkTitle': 'Dodaj dane',
	'selectSourcesText': 'Wybierz i dodaj źródło danych, aby zbudować %{app}.',
	'selectSourcesLabel': 'Wybierz źródło',
	'errorSourcesTitle': 'Nie powiodło się załadowanie drzewa danych',
	'errorLoadingDataSources': 'Wystąpił błąd podczas ładowania listy zbiorów danych',
	'errorLoadingDataTree': 'Wystąpił błąd podczas ładowania drzewa',
	'dataSetPaneLastUpdated': 'Ostatnia aktualizacja: %{date}',
	'dataSourcePaneDateUnknown': 'Nieznane',
	'moreTitle': 'Więcej',
	'backLabel': 'Wstecz',
	'addDataSourceDialogTitle': 'Wybierz źródło',
	'addDataSourceDialogButtonLabel': 'Dodaj',
	'dlg_use': 'Użyj',
	'dlg_RelinkDataSourceTitle': 'Zastąp zestaw danych "%{dataSourceName}" zestawem...',
	'propertiesDialogTitle': 'Właściwości',
	'loadingMetadata': 'Ładowanie metadanych',
	'missingDataSetData': 'Dane tego zestawu danych nie są dostępne. Odśwież zestaw danych lub skontaktuj się z administratorem w sprawie dostępu do źródła.',
	'errorLoadingSource': 'Metadane dla "%{sourceName}" nie zostały załadowane. Skontaktuj się z administratorem w sprawie szczegółów.',
	'errorMessageTitle': 'Błąd',
	'calculation_navigation_in_use': 'Usunięcie obliczeń, filtrów lub ścieżek nawigacji unieważnia wszystkie wizualizacje, które odwołują się do usuniętego elementu. Czy na pewno chcesz usunąć?',
	'delete_confirm': 'Potwierdź usunięcie',
	'previewUnavailable': 'Panel danych i filtry globalne są niedostępne dla pakietów tego typu.',
	'contextualGridTabName': 'Dane wizualizacji',
	'DATA_TRAY_no_data_text': 'Aktualnie nie masz żadnych danych',
	'contextualGridMenuLabel': 'Menu danych wizualizacji',
	'contextualGridExport': 'Eksport',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Szczegóły statystyczne prognozy',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Miary dokładności',
	'forecastDetailsSmoothingCoefLabel': 'Parametry',
	'forecastDetailsDiagnostics': 'Diagnostyka',
	'forecastDetailsForecastLabel': 'Prognoza',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Dokładność %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Sezonowość',
	'forecastDetailsSeasonalPeriodLabel': 'Okres z sezonowością',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Licznik brakujących',
	'forecastDetailsSeriesLengthLabel': 'Długość serii',
	'forecastDetailsIgnoredPeriods': 'Okresy ignorowane',
	'forecastDetailsTrendStrength': 'Siła trendu',
	'forecastDetailsSeasonalityStrength': 'Siła sezonowości',
	'forecastDetailsTimeDeltaUnit': 'Przedział daty/godziny',
	'forecastDetailsNotes': 'Uwagi'
});
